// Module
var code = "<div class=\"history__info inter regular p3\"></div> <template id=\"history__info__item-template\"> <div class=\"history__info__item\"></div> </template> ";
// Exports
export default code;